module.exports = __webpack_public_path__ + "img/bjgd_dark.dc64c035.png";